import { render, staticRenderFns } from "./select-trakt-lists.vue?vue&type=template&id=20efe074&scoped=true"
import script from "./select-trakt-lists.vue?vue&type=script&lang=js"
export * from "./select-trakt-lists.vue?vue&type=script&lang=js"
import style0 from "./select-trakt-lists.vue?vue&type=style&index=0&id=20efe074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efe074",
  null
  
)

export default component.exports